<template>
  <div class="login-wrap">
    <div class="login-card">
      <h2>광고캐시백 로그인</h2>

      <!-- 로그인 폼 -->
      <div v-if="!mustChange">
        <label>로그인ID</label>
        <input v-model="loginId" type="text" placeholder="예) user00001" @keyup.enter="doLogin" />
        <label>비밀번호</label>
        <input v-model="password" type="password" placeholder="초기 비밀번호 123456" @keyup.enter="doLogin" />
        <button class="primary" :disabled="loading" @click="doLogin">로그인</button>
        <p class="hint">
          최초 로그인 시 원하는 비밀번호로 변경해야 합니다.
        </p>
      </div>

      <!-- 최초 비밀번호 변경 -->
      <div v-else>
        <p class="notice">최초 로그인입니다. 새 비밀번호를 설정하세요.</p>
        <label>현재(초기) 비밀번호</label>
        <input v-model="password" type="password" />
        <label>새 비밀번호</label>
        <input v-model="newPassword" type="password" placeholder="4자 이상" />
        <label>새 비밀번호 확인</label>
        <input v-model="newPassword2" type="password" @keyup.enter="doChange" />
        <button class="primary" :disabled="loading" @click="doChange">비밀번호 변경 후 로그인</button>
      </div>

      <p v-if="error" class="error">{{ error }}</p>

      <!-- 운영자 로그인 (cafe24 OAuth) + 로그인2 (쇼핑몰 회원).
           스펙46: 하드코딩 사용유무=true 이면 노출하지 않음(운영자 로그인은 false 일 때만 가능). -->
      <div v-if="!mustChange && operatorLoginEnabled" class="operator-area">
        <div class="divider"></div>
        <button class="operator-btn" @click="operatorLogin">운영자 로그인</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';
import { setAuth } from '../store/auth';

export default {
  name: 'Login',
  data() {
    return {
      loginId: '', password: '', newPassword: '', newPassword2: '',
      mustChange: false, loading: false, error: '',
      operatorLoginEnabled: false   // 스펙46: 하드코딩 사용유무=false 일 때만 운영자 로그인 노출
    };
  },
  created() {
    this.loadLoginOptions();
    // cafe24 운영자 로그인 콜백 결과 처리
    const op = this.$route.query.operator;
    if (op === 'success') {
      setAuth({ customerId: null, loginId: 'operator', name: '운영자', role: 'admin' });
      this.$router.push('/point');
    } else if (op === 'fail') {
      this.error = '운영자 로그인(cafe24)에 실패했습니다.';
    }
  },
  methods: {
    async loadLoginOptions() {
      try {
        const res = await api.cafe24LoginOptions();
        this.operatorLoginEnabled = !!(res.data && res.data.operatorLoginEnabled);
      } catch (e) {
        this.operatorLoginEnabled = false;   // 조회 실패 시 안전하게 숨김
      }
    },
    async operatorLogin() {
      this.error = '';
      try {
        const res = await api.cafe24OauthUrl();
        window.location.href = res.data.url;   // cafe24 로그인 화면으로 이동
      } catch (e) {
        this.error = '운영자 로그인 URL 요청 실패: ' + e.message;
      }
    },
    async mallLogin() {
      this.error = '';
      try {
        const res = await api.cafe24MallLoginUrl();
        window.location.href = res.data.url;   // cafe24 쇼핑몰 로그인 화면으로 이동
      } catch (e) {
        this.error = '로그인2 URL 요청 실패: ' + e.message;
      }
    },
    async doLogin() {
      this.error = '';
      if (!this.loginId || !this.password) { this.error = '로그인ID와 비밀번호를 입력하세요.'; return; }
      this.loading = true;
      try {
        const res = await api.login(this.loginId, this.password);
        if (res.data.mustChangePassword) {
          this.mustChange = true;         // 최초 로그인 → 변경 유도
        } else {
          this.enter(res.data);
        }
      } catch (e) {
        this.error = e.message;
      } finally {
        this.loading = false;
      }
    },
    async doChange() {
      this.error = '';
      if (this.newPassword.length < 4) { this.error = '새 비밀번호는 4자 이상이어야 합니다.'; return; }
      if (this.newPassword !== this.newPassword2) { this.error = '새 비밀번호가 일치하지 않습니다.'; return; }
      this.loading = true;
      try {
        await api.changePassword(this.loginId, this.password, this.newPassword);
        // 변경된 비밀번호로 재로그인
        const res = await api.login(this.loginId, this.newPassword);
        this.enter(res.data);
      } catch (e) {
        this.error = e.message;
      } finally {
        this.loading = false;
      }
    },
    enter(user) {
      setAuth(user);
      this.$router.push('/point');
    }
  }
};
</script>

<style scoped>
.login-wrap { display: flex; justify-content: center; align-items: center; min-height: 70vh; }
.login-card { width: 360px; background: #fff; padding: 30px 28px; border-radius: 10px; box-shadow: 0 6px 24px rgba(0,0,0,.08); }
.login-card h2 { margin: 0 0 20px; font-size: 20px; text-align: center; }
label { display: block; font-size: 13px; color: #555; margin: 12px 0 4px; }
input { width: 100%; padding: 10px; border: 1px solid #d0d5dd; border-radius: 6px; font-size: 14px; }
button.primary { width: 100%; margin-top: 18px; padding: 11px; background: #2f6fed; color: #fff; border: none; border-radius: 6px; font-size: 15px; cursor: pointer; }
button.primary:disabled { background: #9db8ef; }
.hint { font-size: 12px; color: #888; margin-top: 12px; text-align: center; }
.notice { font-size: 13px; color: #2f6fed; margin-bottom: 6px; }
.error { color: #d93636; font-size: 13px; margin-top: 12px; text-align: center; }
.operator-area { margin-top: 18px; }
.divider { height: 1px; background: #e2e6ee; margin: 6px 0 16px; }
.operator-btn { width: 100%; padding: 11px; background: #1a1a1a; color: #fff; border: none; border-radius: 6px; font-size: 15px; cursor: pointer; }
.operator-btn:hover { background: #000; }
.mall-btn { width: 100%; margin-top: 10px; padding: 11px; background: #2f6fed; color: #fff; border: none; border-radius: 6px; font-size: 15px; cursor: pointer; }
.mall-btn:hover { background: #245bd0; }
.hint2 { font-size: 11.5px; color: #999; margin-top: 8px; text-align: center; }
</style>
